import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { AuthService } from '@core/auth/auth.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthRequestInterceptor } from '@core/interceptors/auth-request.interceptor';
import { AuthResponseInterceptor } from '@core/interceptors/auth-response.interceptor';
import { ScriptLoaderService } from '@core/script-loader/script-loader.service';

export function loadScriptsFactory(scriptLoaderService: ScriptLoaderService) {
  return () => scriptLoaderService.loadScript();
}

@NgModule({
  declarations: [],
  providers: [
    AuthService,
    AuthGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthRequestInterceptor,
      multi: true
    }, {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthResponseInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadScriptsFactory,
      deps: [ScriptLoaderService],
      multi: true
    }
  ],
  imports: [
    CommonModule
  ]
})
export class CoreModule {
}
